(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/canvas/util.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/canvas/util.js');
"use strict";


function easeOutBounce(x) {
  const n1 = 7.5625;
  const d1 = 2.75;
  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  }
  return n1 * (x -= 2.625 / d1) * x + 0.984375;
}

function remapTime(progress, start, end) {
  if (progress < start) {
    return 0.0;
  }
  if (progress > end) {
    return 1.0;
  }
  return (progress - start) / (end - start);
}

function lerp(a, b, t) {
  return t * (b - a) + a;
}
setGlobal('svs.bingo_react.components.bingoCard.canvas.Util', {
  easeOutBounce,
  remapTime,
  lerp
});

 })(window);